var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"accessDenied"}},[_c('v-container',{attrs:{"max-width":"600"}},[_c('v-row',[_c('v-spacer'),_c('v-col',{attrs:{"md":"8"}},[_c('img',{attrs:{"src":"/img/access-denied.svg","alt":"Access Denied"}}),_c('h1',[_vm._v("You do not have access to this resource")])]),_c('v-spacer')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }